// @ts-expect-error
import type {DataProxy, FetchResult} from 'react-apollo';

import type {
    GetTaskSync as GetTaskSyncQuery,
    setGoogleTaskSyncIsEnabled as setGoogleTaskSyncIsEnabledMutation,
} from 'nutshell-graphql-types';

import {getTaskSync} from '../integrations/integration-mutation-response-helpers';

import GET_TASK_SYNC_QUERY from './graphql/queries/get-task-sync.graphql';

type MutationResult = FetchResult<setGoogleTaskSyncIsEnabledMutation>;

export function updateCacheFromMutation(proxy: DataProxy, mutationResult: MutationResult) {
    const newTaskSync = getTaskSync(mutationResult);
    if (!newTaskSync) {
        return;
    }

    const cacheResult: GetTaskSyncQuery | null | undefined = proxy.readQuery({
        query: GET_TASK_SYNC_QUERY,
    });

    if (cacheResult) {
        proxy.writeQuery({
            query: GET_TASK_SYNC_QUERY,
            data: {
                loggedInUser: {
                    ...cacheResult.loggedInUser,
                    taskSync: newTaskSync,
                },
            },
        });
    }
}
